/**
 * Of a "Nickname — Type" name the nickname wears the graffiti hand and
 * the type becomes the small line under it. A name without the dash is
 * all title.
 *
 * Product names are English on both storefronts, so the nickname is
 * the first half in practice; the Latin ratio is kept for the pieces
 * still carrying a Russian "Тип — Nickname" name from before that rule.
 *
 * The landing's tiles and the product page both key off this, which is
 * why it lives here rather than beside either of them.
 */
export function splitName(name: string): { title: string; sub: string | null } {
  const dash = name.indexOf('—')
  if (dash === -1) return { title: name, sub: null }

  const a = name.slice(0, dash).trim()
  const b = name.slice(dash + 1).trim()
  if (!a || !b) return { title: name, sub: null }

  // Ratio over letters only — spaces would dilute a multi-word
  // nickname below a one-word type. The first half is the nickname
  // unless it's mostly non-Latin (the Russian "Тип — Nickname" order).
  const latin = (s: string) => {
    const letters = s.match(/\p{L}/gu) ?? []
    return letters.filter((ch) => /[A-Za-z]/.test(ch)).length / Math.max(letters.length, 1)
  }
  return latin(a) >= 0.5 ? { title: a, sub: b } : { title: b, sub: a }
}
